module.exports = __webpack_public_path__ + "img/rami-logos.de93653f.png";